import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import PlanTimestamp from 'workspace/PlanTimestamp'
import PlanTable from 'workspace/PlanTable'
import RealizationScrapPercentage from 'workspace/RealizationScrapPercentage'
import RealizationScrapTables from 'workspace/RealizationScrapTables'
import RealizationTimelines from 'workspace/RealizationTimelines'
import RealizationSummaryTimelines from 'workspace/RealizationSummaryTimelines'
import FormreinigerTimelines from 'workspace/FormreinigerTimelines'
import { selectMode } from 'workspace/selectors'
import { Modes } from 'workspace/const'
import PlanSearch from './PlanSearch'

const WorkspaceTimelines = ({ mode }) => (
  <React.Fragment>
    {
      mode === Modes.FORMREINIGER &&
      <>
        <div className='timeline-group'>
          <h2 className='timeline-group__header'>
            <FormattedMessage
              id='workspace.timelines.changeovers'
              defaultMessage='Changeovers'
              description='Changeovers timelines header'
            />
          </h2>
          <FormreinigerTimelines />
        </div>
        <div className='timeline-group'>
          <h2 className='timeline-group__header'>
            <FormattedMessage
              id='workspace.timelines.realization'
              defaultMessage='Realization'
              description='Realization timelines header'
            />
          </h2>
        </div>
      </>
    }

    {
      mode === 'realization' &&
      <div className='timeline-group'>
        <h2 className='timeline-group__header'>
          <FormattedMessage
            id='workspace.timelines.plan'
            defaultMessage='Plan'
            description='Plan timelines header'
          />
          <PlanTimestamp />
        </h2>
      </div>
    }

    {
      mode === Modes.PLANNING &&
      <div className='timeline-group'>
        <h2 className='timeline-group__header'>
          <FormattedMessage
            id='workspace.timelines.plan'
            defaultMessage='Plan'
            description='Plan timelines header'
          />

          <PlanSearch />
        </h2>
        <PlanTable />
      </div>
    }

    {
      mode === 'realization' &&
      <div className='timeline-group'>
        <h2 className='timeline-group__header'>
          <FormattedMessage
            id='workspace.timelines.realization'
            defaultMessage='Realization'
            description='Realization timelines header'
          />
        </h2>
        <RealizationTimelines />
      </div>
    }

    {
      mode === 'realization' &&
      <div className='timeline-group'>
        <h2 className='timeline-group__header'>
          <FormattedMessage
            id='workspace.timelines.summary'
            defaultMessage='WAB'
            description='Summary timelines header'
          />
        </h2>
        <RealizationSummaryTimelines />
      </div>
    }

    {
      mode === 'realization' &&
      <div className='timeline-group'>
        <h2 className='timeline-group__header'>
          <FormattedMessage
            id='workspace.timelines.scrap'
            defaultMessage='Scrap'
            description='Scrap table header'
          />
          <RealizationScrapPercentage />
        </h2>
        <RealizationScrapTables />
      </div>
    }
  </React.Fragment>
)

WorkspaceTimelines.propTypes = {
  mode: Modes.propType
}

const mapStateToProps = (state) => ({
  mode: selectMode(state)
})

export default connect(mapStateToProps)(WorkspaceTimelines)
